"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MeteoApi = exports.WindSpeedCode = exports.WindCode = exports.TimeStepCode = exports.ForecastParamCode = exports.PrecipitationCode = exports.SkyCode = exports.OtherCode = void 0;
const axios_1 = require("axios");
const globalImportUrl = require("url");
const base_1 = require("../base");
var OtherCode;
(function (OtherCode) {
    OtherCode["Haze"] = "haze";
    OtherCode["BlackIce"] = "black_ice";
    OtherCode["Thunder"] = "thunder";
    OtherCode["Flood"] = "flood";
})(OtherCode = exports.OtherCode || (exports.OtherCode = {}));
var SkyCode;
(function (SkyCode) {
    SkyCode["Clear"] = "clear";
    SkyCode["PartlyCloudy"] = "partlyCloudy";
    SkyCode["Overcast"] = "overcast";
    SkyCode["Mist"] = "mist";
    SkyCode["Rain"] = "rain";
    SkyCode["Storm"] = "storm";
    SkyCode["Snowy"] = "snowy";
})(SkyCode = exports.SkyCode || (exports.SkyCode = {}));
var PrecipitationCode;
(function (PrecipitationCode) {
    PrecipitationCode["LightRain"] = "lightRain";
    PrecipitationCode["HeavyRain"] = "heavyRain";
    PrecipitationCode["Showers"] = "showers";
    PrecipitationCode["RainAndSnow"] = "rainAndSnow";
    PrecipitationCode["Snow"] = "snow";
    PrecipitationCode["Drizzle"] = "drizzle";
    PrecipitationCode["Hail"] = "hail";
})(PrecipitationCode = exports.PrecipitationCode || (exports.PrecipitationCode = {}));
var ForecastParamCode;
(function (ForecastParamCode) {
    ForecastParamCode["weatherCode"] = "weatherCode";
    ForecastParamCode["moonPhase"] = "moonPhase";
    ForecastParamCode["sunset"] = "sunset";
    ForecastParamCode["sunrise"] = "sunrise";
    ForecastParamCode["dewPointTemperature"] = "dewPointTemperature";
    ForecastParamCode["airTemperature"] = "airTemperature";
    ForecastParamCode["airTemperatureNearGround"] = "airTemperatureNearGround";
    ForecastParamCode["minAirTemperature"] = "minAirTemperature";
    ForecastParamCode["maxAirTemperature"] = "maxAirTemperature";
    ForecastParamCode["feelsLikeTemperature"] = "feelsLikeTemperature";
    ForecastParamCode["minAirTemperatureNearGround"] = "minAirTemperatureNearGround";
    ForecastParamCode["airPressure"] = "airPressure";
    ForecastParamCode["windDirection"] = "windDirection";
    ForecastParamCode["maxWindGustAt2m"] = "maxWindGustAt2m";
    ForecastParamCode["windSpeedAt2m"] = "windSpeedAt2m";
    ForecastParamCode["precipitationAmount"] = "precipitationAmount";
    ForecastParamCode["precipitationProbability"] = "precipitationProbability";
    ForecastParamCode["relativeHumidity"] = "relativeHumidity";
    ForecastParamCode["effectiveCloudCover"] = "effectiveCloudCover";
    ForecastParamCode["evapotranspiration"] = "evapotranspiration";
    ForecastParamCode["radiation"] = "radiation";
    ForecastParamCode["uvIndex"] = "uvIndex";
    ForecastParamCode["sunshineDuration"] = "sunshineDuration";
    ForecastParamCode["saturationDeficit"] = "saturationDeficit";
    ForecastParamCode["groundFrostProbability"] = "groundFrostProbability";
    ForecastParamCode["leafWetness"] = "leafWetness";
    ForecastParamCode["growingDegreeDaysAccumulated"] = "growingDegreeDaysAccumulated";
    ForecastParamCode["volumetricSoilWaterMeanAt5cm"] = "volumetricSoilWaterMeanAt5cm";
    ForecastParamCode["volumetricSoilWaterMeanAt50cm"] = "volumetricSoilWaterMeanAt50cm";
    ForecastParamCode["nbMetrics"] = "nbMetrics";
})(ForecastParamCode = exports.ForecastParamCode || (exports.ForecastParamCode = {}));
var TimeStepCode;
(function (TimeStepCode) {
    TimeStepCode["TimeStep1"] = "timeStep1";
    TimeStepCode["TimeStep3"] = "timeStep3";
    TimeStepCode["TimeStep24"] = "timeStep24";
})(TimeStepCode = exports.TimeStepCode || (exports.TimeStepCode = {}));
var WindCode;
(function (WindCode) {
    WindCode["N"] = "N";
    WindCode["NE"] = "NE";
    WindCode["E"] = "E";
    WindCode["SE"] = "SE";
    WindCode["S"] = "S";
    WindCode["SW"] = "SW";
    WindCode["W"] = "W";
    WindCode["NW"] = "NW";
})(WindCode = exports.WindCode || (exports.WindCode = {}));
var WindSpeedCode;
(function (WindSpeedCode) {
    WindSpeedCode["Calm"] = "calm";
    WindSpeedCode["Weak"] = "weak";
    WindSpeedCode["Moderate"] = "moderate";
    WindSpeedCode["FairlyStrong"] = "fairly_strong";
    WindSpeedCode["Strong"] = "strong";
    WindSpeedCode["VeryStrong"] = "very_strong";
})(WindSpeedCode = exports.WindSpeedCode || (exports.WindSpeedCode = {}));
function MeteoApiAxiosParamCreator(configuration) {
    return {
        getForecastTransparency(options = {}) {
            const localVarPath = `/forecast-transparency`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: "GET" }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarUrlObj.query = Object.assign(Object.assign(Object.assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign(Object.assign({}, localVarHeaderParameter), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getForecastTrends(regionCode, options = {}) {
            if (regionCode === null || regionCode === undefined) {
                throw new base_1.RequiredError("regionCode", "Required parameter regionCode was null or undefined when calling getForecastTrends.");
            }
            const localVarPath = `/forecast-trends`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: "GET" }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (regionCode !== undefined) {
                localVarQueryParameter["regionCode"] = regionCode;
            }
            localVarUrlObj.query = Object.assign(Object.assign(Object.assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign(Object.assign({}, localVarHeaderParameter), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getForecasts(latitude, longitude, path, date, page) {
            if (latitude === null || latitude === undefined) {
                throw new base_1.RequiredError("latitude", "Required parameter latitude was null or undefined when calling getForecasts.");
            }
            if (longitude === null || longitude === undefined) {
                throw new base_1.RequiredError("longitude", "Required parameter longitude was null or undefined when calling getForecasts.");
            }
            let url = path;
            url += '?latitude=' + encodeURIComponent(latitude);
            url += '&longitude=' + encodeURIComponent(longitude);
            if (date) {
                url += '&date=' + encodeURIComponent(date);
            }
            if (page !== undefined) {
                url += '&page=' + page;
            }
            return {
                url: url.toString(),
                options: Object.assign({ method: "GET" }, configuration === null || configuration === void 0 ? void 0 : configuration.baseOptions)
            };
        },
        getParticipatoryForecast(participatoryForecastId, options = {}) {
            if (participatoryForecastId === null ||
                participatoryForecastId === undefined) {
                throw new base_1.RequiredError("participatoryForecastId", "Required parameter participatoryForecastId was null or undefined when calling getParticipatoryForecast.");
            }
            const localVarPath = `/participatory-forecasts/{participatoryForecastId}`.replace(`{${"participatoryForecastId"}}`, encodeURIComponent(String(participatoryForecastId)));
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: "GET" }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarUrlObj.query = Object.assign(Object.assign(Object.assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign(Object.assign({}, localVarHeaderParameter), options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        postParticipatoryForecast(PostParticipatoryForecast, options = {}) {
            if (PostParticipatoryForecast === null ||
                PostParticipatoryForecast === undefined) {
                throw new base_1.RequiredError("PostParticipatoryForecast", "Required parameter PostParticipatoryForecast was null or undefined when calling postParticipatoryForecast.");
            }
            const localVarPath = `/participatory-forecasts`;
            const localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: "POST" }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter["Content-Type"] = "multipart/form-data";
            localVarUrlObj.query = Object.assign(Object.assign(Object.assign({}, localVarUrlObj.query), localVarQueryParameter), options.query);
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign(Object.assign({}, localVarHeaderParameter), options.headers);
            const needsSerialization = typeof PostParticipatoryForecast !== "string" ||
                localVarRequestOptions.headers["Content-Type"] === "application/json";
            localVarRequestOptions.data = needsSerialization
                ? JSON.stringify(PostParticipatoryForecast !== undefined
                    ? PostParticipatoryForecast
                    : {})
                : PostParticipatoryForecast || "";
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
}
function MeteoApiFp(configuration) {
    return {
        getForecastTransparency(options) {
            const localVarAxiosArgs = MeteoApiAxiosParamCreator(configuration).getForecastTransparency(options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        getForecastTrends(regionCode, options) {
            const localVarAxiosArgs = MeteoApiAxiosParamCreator(configuration).getForecastTrends(regionCode, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        getSummaryForecasts(latitude, longitude) {
            const localVarAxiosArgs = MeteoApiAxiosParamCreator(configuration).getForecasts(latitude, longitude, '/forecasts-summary');
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        get15dForecasts(latitude, longitude, page) {
            const localVarAxiosArgs = MeteoApiAxiosParamCreator(configuration).getForecasts(latitude, longitude, '/forecasts-15d', undefined, page);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = { url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        get36hForecasts(latitude, longitude, page) {
            const localVarAxiosArgs = MeteoApiAxiosParamCreator(configuration).getForecasts(latitude, longitude, '/forecasts-36h', undefined, page);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = { url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        getHourlyForecasts(latitude, longitude, date, page) {
            if (date === null || date === undefined) {
                throw new base_1.RequiredError("date", "Required parameter date was null or undefined when calling getForecasts.");
            }
            const localVarAxiosArgs = MeteoApiAxiosParamCreator(configuration).getForecasts(latitude, longitude, '/forecasts-hourly', date, page);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = { url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        getWeeklyForecasts(latitude, longitude) {
            const localVarAxiosArgs = MeteoApiAxiosParamCreator(configuration).getForecasts(latitude, longitude, '/forecasts-weekly');
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = { url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        getTreatmentSchedule(latitude, longitude) {
            const localVarAxiosArgs = MeteoApiAxiosParamCreator(configuration).getForecasts(latitude, longitude, '/treatment-schedule');
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = { url: basePath + localVarAxiosArgs.url };
                return axios.request(axiosRequestArgs);
            };
        },
        getParticipatoryForecast(participatoryForecastId, options) {
            const localVarAxiosArgs = MeteoApiAxiosParamCreator(configuration).getParticipatoryForecast(participatoryForecastId, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        postParticipatoryForecast(PostParticipatoryForecast, options) {
            const localVarAxiosArgs = MeteoApiAxiosParamCreator(configuration).postParticipatoryForecast(PostParticipatoryForecast, options);
            return (axios = axios_1.default, basePath = base_1.BASE_PATH) => {
                const axiosRequestArgs = Object.assign(Object.assign({}, localVarAxiosArgs.options), { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
    };
}
class MeteoApi extends base_1.BaseAPI {
    getForecastTransparency(options) {
        return MeteoApiFp(this.configuration).getForecastTransparency(options)(this.axios, this.basePath);
    }
    getForecastTrends(regionCode, options) {
        return MeteoApiFp(this.configuration).getForecastTrends(regionCode, options)(this.axios, this.basePath);
    }
    getSummaryForecasts(latitude, longitude) {
        return MeteoApiFp(this.configuration).getSummaryForecasts(latitude, longitude)(this.axios, this.basePath);
    }
    get36hForecasts(latitude, longitude, page) {
        return MeteoApiFp(this.configuration).get36hForecasts(latitude, longitude, page)(this.axios, this.basePath);
    }
    getHourlyForecasts(latitude, longitude, date, page) {
        return MeteoApiFp(this.configuration).getHourlyForecasts(latitude, longitude, date, page)(this.axios, this.basePath);
    }
    get15dForecasts(latitude, longitude, page) {
        return MeteoApiFp(this.configuration).get15dForecasts(latitude, longitude, page)(this.axios, this.basePath);
    }
    getWeeklyForecasts(latitude, longitude) {
        return MeteoApiFp(this.configuration).getWeeklyForecasts(latitude, longitude)(this.axios, this.basePath);
    }
    getTreatmentSchedule(latitude, longitude) {
        return MeteoApiFp(this.configuration).getTreatmentSchedule(latitude, longitude)(this.axios, this.basePath);
    }
    getParticipatoryForecast(participatoryForecastId, options) {
        return MeteoApiFp(this.configuration).getParticipatoryForecast(participatoryForecastId, options)(this.axios, this.basePath);
    }
    postParticipatoryForecast(PostParticipatoryForecast, options) {
        return MeteoApiFp(this.configuration).postParticipatoryForecast(PostParticipatoryForecast, options)(this.axios, this.basePath);
    }
}
exports.MeteoApi = MeteoApi;
